import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const BrandingRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.customize(),
    element: (
      <StandardPageLayout elementId="brandingRoute" maxWidth={900} title={<T _str="Branding" />}>
        <Suspense fallback={<RouteLoading />}>
          <BrandingRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
